export enum WindowTypes {
	desktop = 'desktop',
	laptop = 'laptop',
	tablet = 'tablet',
	mobile = 'mobile',
}
export type TWindowType = keyof typeof WindowTypes;

/* --- STATE --- */
export interface PageStoreState {
	windowType: TWindowType;
	isSmallScreen: boolean;
}
